<template>
    <div>
        <div>
            <div>Pricing Model</div>
            <div v-show="show_list.pricing_model">
                <mm-offer-pricing-model @change="changeRule" v-model="input_list.pricing_model" multiple />
            <el-button type="danger" @click="delRule('pricing_model')">DEL</el-button>
            </div>
            <div v-show="!show_list.pricing_model">
                <el-button type="success" @click="addRule('pricing_model')">Add</el-button>
            </div>
        </div>
        <div>
            <div>Regions</div>
                <div v-show="show_list.geos">
                    <mm-offer-geos @change="changeRule" v-model="input_list.geos" multiple />
                    <el-button type="danger" @click="delRule('geos')">DEL</el-button>
                </div>
                <div v-show="!show_list.geos">
                    <el-button type="success" @click="addRule('geos')">Add</el-button>
                </div>
        </div>
        <div>
            <div>Platforms</div>
            <div v-show="show_list.platform">
            <mm-offer-platform @change="changeRule" v-model="input_list.platform" multiple />
            <el-button type="danger" @click="delRule('platform')">DEL</el-button>
                </div>
                <div v-show="!show_list.platform">
                    <el-button type="success" @click="addRule('platform')">Add</el-button>
                </div>
        </div>
        <div>
            <div>Offer Price</div>
            <div v-show="show_list.offer_price">
            <mm-number-range @change="changeRule" v-model="input_list.offer_price"  />
            <el-button type="danger" @click="delRule('offer_price')">DEL</el-button>
                </div>
                <div v-show="!show_list.offer_price">
                    <el-button type="success" @click="addRule('offer_price')">Add</el-button>
                </div>
        </div>
        <!-- <div>
            <div>Traffic Type</div>
            <div v-show="show_list.traffic_type">
            <mm-offer-traffic-type @change="changeRule" v-model="input_list.traffic_type" multiple />
            <el-button type="danger" @click="delRule('traffic_type')">DEL</el-button>
                </div>
                <div v-show="!show_list.traffic_type">
                    <el-button type="success" @click="addRule('traffic_type')">Add</el-button>
                </div>
        </div> -->
        
    </div>
</template>

<script>
export default {
	data() {
		return{
			input_list:{
				geos:'',
				platform:'',
				pricing_model:'',
				offer_price:'',
			},
			show_list:{
				pricing_model:false,
				geos:false,
				platform:false,
				offer_price:false
			}
		}
	},
	props:['value'],
	watch: {
		value:function(rules_json) {
			const rules_obj = JSON.parse(rules_json);
			for(const type in rules_obj){
				if(rules_obj[type] !== '') {
					this.input_list[type] = rules_obj[type];
					this.show_list[type] = true;
				}
			}
            
		}
	},
	methods: {
		changeRule(){
			for(const type in this.input_list) {
				if(this.input_list[type] === '') {
					delete this.input_list[type];
				}
			}
			this.$emit('input',JSON.stringify(this.input_list));
		},
		delRule(rule){
			this.show_list[rule] = false;
			delete this.input_list[rule];
			this.changeRule();
		},
		addRule(rule){
			this.show_list[rule] = true;
		}
	}
}
</script>
